/**
 * resolveDropsFetchLength
 * For Media Devoted | Created By Ciro Autiero
 */

import {
  capManualFetchLength,
  DROPS_FETCH_LENGTH_DEFAULT,
  getDropsFetchPlan,
} from '@trafficpulse/shared';

function toIsoStart(ymd: string): string | undefined {
  return ymd ? `${ymd}T00:00:00.000Z` : undefined;
}

function toIsoEnd(ymd: string): string | undefined {
  return ymd ? `${ymd}T23:59:59.999Z` : undefined;
}

function planParams(dateFrom: string, dateTo: string) {
  return {
    from: toIsoStart(dateFrom),
    to: toIsoEnd(dateTo),
  };
}

/** Suggested Fetch target when both date bounds are set (150 drops/day + buffer). */
export function getSuggestedDropsFetchLength(dateFrom: string, dateTo: string): number {
  if (!dateFrom || !dateTo) return DROPS_FETCH_LENGTH_DEFAULT;
  return getDropsFetchPlan(planParams(dateFrom, dateTo)).estimatedTotal;
}

/** Manual fetch: capped at 5000. Date range: max(manual, estimatedTotal), uncapped. */
export function resolveDropsFetchLength(params: {
  manualLength: number;
  dateFrom: string;
  dateTo: string;
}): number {
  const manual = Math.max(1, Math.floor(params.manualLength || 0));
  if (!params.dateFrom || !params.dateTo) {
    return capManualFetchLength(manual);
  }

  const plan = getDropsFetchPlan(planParams(params.dateFrom, params.dateTo));
  return Math.max(manual, plan.estimatedTotal);
}
